import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { TtrpgApp } from "@/components/ttrpg-app";
import { useAuthToken } from "@/hooks/use-auth-token";
import logger from "@/lib/logger";

export default function CampaignPage() {
  const { id: campaignId } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { getToken, authDisabled, loading } = useAuthToken();
  const [token, setToken] = useState<string | undefined>(undefined);

  useEffect(() => {
    // Wait for auth config to load before deciding
    if (loading) {
      return;
    }
    if (authDisabled) {
      // No token needed — server bypasses auth
      return;
    }
    getToken()
      .then((t) => {
        if (!t) {
          navigate("/login");
          return;
        }
        setToken(t);
      })
      .catch((err) => logger.error({ err }, "Failed to get ID token"));
  }, [loading, authDisabled, getToken, navigate]);

  // Fire-and-forget prewarm to absorb agent Cloud Run cold-start.
  // Errors are intentionally silent — warmup is pure optimisation and
  // a failure is not user-actionable. See LAF-51 design spec.
  useEffect(() => {
    // biome-ignore lint/suspicious/noEmptyBlockStatements: intentional silent catch
    fetch("/api/warmup").catch(() => {});
  }, []);

  if (!campaignId) {
    navigate("/launch");
    return null;
  }

  return <TtrpgApp campaignId={campaignId} token={token} />;
}
